import http from "../../http";
import { useQuery, useMutation } from "../../../contexts/HttpQueryContext";

export function useGetCurrentSession({ options = {} } = {}) {
  return useQuery({
    ...options,
    queryKey: ["Auth::Session::GetCurrentSession"],
    queryFn: () => {
      const url = http.url("auth.session.currentSession");
      return http.api.get(url);
    },
  });
}

export function useGetActiveSessions({ options = {} } = {}) {
  return useQuery({
    ...options,
    queryKey: ["Auth::Session::GetActiveSessions"],
    queryFn: async () => {
      const url = http.url("auth.session.getActiveSessions");
      const response = await http.api.get(url);

      return response.data;
    },
  });
}

export function useTerminateSession() {
  return useMutation({
    mutationFn: async (tokenId) => {
      const url = http.url("auth.session.terminate");
      return await http.api.post(url, { token_id: tokenId });
    },
  });
}

export function useTerminateAllSessions() {
  return useMutation({
    mutationFn: async () => {
      const url = http.url("auth.session.terminateAll");
      return await http.api.post(url);
    },
  });
}
